/* =========================================================
 CST SUPPORT FORMS
 author: cembry@atlassian.com

 This library is the front end form code that is meant to be used with SAC vNext issue creation services.
 https://stash.atlassian.com/projects/CST/repos/cst-support-services/browse

 This library is dependent on AUI form validation and AUI messages.
 ========================================================= */

import * as $ from "jquery";
import imkt from '../../../imkt';
import url from '../../../utils/url';
import tracking from '../../../utils/tracking';

var cst = window.cst || (window.cst = {});

/* jshint -W117 */
cst.support = {
  scrollTo: function (selector, speed) {
    var element = $(selector);
    $("html, body").animate(
      {
        scrollTop: element.offset().top - element.height() - 10,
      },
      speed
    );
  },
};

// functions copied from https://ace-cdn.atlassian.com/stp/current/analytics/js/atl-analytics.js
cst.support.ace = {
  guidNoDashes: function () {
    return cst.support.ace.guid().replace(/-/g, "");
  },

  trueRandom: (function () {
    function Mash() {
      var n = 0xefc8249d;

      var mash = function (data) {
        data = data.toString();
        for (var i = 0; i < data.length; i++) {
          n += data.charCodeAt(i);
          var h = 0.02519603282416938 * n;
          n = h >>> 0;
          h -= n;
          h *= n;
          n = h >>> 0;
          h -= n;
          n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
      };

      mash.version = "Mash 0.9";
      return mash;
    }

    function Alea() {
      return (function (args) {
        // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
        var s0 = 0;
        var s1 = 0;
        var s2 = 0;
        var c = 1;

        if (args.length === 0) {
          args = [+new Date()];
        }
        var mash = Mash();
        s0 = mash(" ");
        s1 = mash(" ");
        s2 = mash(" ");

        for (var i = 0; i < args.length; i++) {
          s0 -= mash(args[i]);
          if (s0 < 0) {
            s0 += 1;
          }
          s1 -= mash(args[i]);
          if (s1 < 0) {
            s1 += 1;
          }
          s2 -= mash(args[i]);
          if (s2 < 0) {
            s2 += 1;
          }
        }
        mash = null;

        /* jshint -W093 */
        var random = function () {
          var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
          s0 = s1;
          s1 = s2;
          return (s2 = t - (c = t | 0));
        };
        random.uint32 = function () {
          return random() * 0x100000000; // 2^32
        };
        random.fract53 = function () {
          return (
            random() + ((random() * 0x200000) | 0) * 1.1102230246251565e-16
          ); // 2^-53
        };
        random.version = "Alea 0.9";
        random.args = args;
        return random;
      })(Array.prototype.slice.call(arguments));
    }

    return Alea();
  })(),

  guid: function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (cst.support.ace.trueRandom() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  },

  readCookie: function (name) {
    try {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
    } catch (e) {}
    return null;
  },

  writeCookie: function (name, value, days, topLevelDomain) {
    try {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      }

      var cookie = name + "=" + value + expires + "; path=/;";

      var domain = window.location.hostname;
      if (domain !== "localhost" && topLevelDomain === true) {
        var domainTokens = domain.split(".");
        if (domainTokens.length > 1) {
          var lastToken = domainTokens[domainTokens.length - 1];
          var secondLastToken = domainTokens[domainTokens.length - 2];
          if (isNaN(lastToken) || isNaN(secondLastToken)) {
            domain = "." + secondLastToken + "." + lastToken;
          }
        }

        cookie += " domain=" + domain + ";";
      }
      document.cookie = cookie;
    } catch (e) {}
  },
};

cst.support.darkfeatures = {
  // we are just using local, dev, and prod LD environments
  initScripts: {
    local:
      '<script crossorigin="anonymous" src="https://app.launchdarkly.com/snippet/features/56a929d4836f3506d400157c.js"></script><script>!function(e,t){function n(e){e.key&&(e.key=e.key.toString())}e.ldclient=e.ldclient||{},e.ldclient.q||(e.ldclient.q=[]),e.ldclient.push_event=function(t,n,i){e.ldclient.q.push({kind:t,key:n,data:i,url:e.location.href,creationDate:new Date})},e.ldclient.track=e.ldclient.send_event=function(t,n){if("string"!=typeof t)throw"Event key must be a string";e.ldclient.push_event("custom",t,n)},e.ldclient.set_user=e.ldclient.identify=e.ldclient.identify||function(t){n(t),e.ldclient.q.push({kind:"identify",key:t.key,user:t,creationDate:new Date}),e.ldclient.user=t};var i=e.document.createElement("script");i.type="text/javascript",i.async=!0,i.crossorigin="anonymous",i.src=t;var c=e.document.getElementsByTagName("script")[0];c.parentNode.insertBefore(i,c)}(this,"https://app.launchdarkly.com/snippet/events/v1/56a929d4836f3506d400157c.js");</script>',
    dev: '<script crossorigin="anonymous" src="https://app.launchdarkly.com/snippet/features/56a929db836f3506d400157e.js"></script><script>!function(e,t){function n(e){e.key&&(e.key=e.key.toString())}e.ldclient=e.ldclient||{},e.ldclient.q||(e.ldclient.q=[]),e.ldclient.push_event=function(t,n,i){e.ldclient.q.push({kind:t,key:n,data:i,url:e.location.href,creationDate:new Date})},e.ldclient.track=e.ldclient.send_event=function(t,n){if("string"!=typeof t)throw"Event key must be a string";e.ldclient.push_event("custom",t,n)},e.ldclient.set_user=e.ldclient.identify=e.ldclient.identify||function(t){n(t),e.ldclient.q.push({kind:"identify",key:t.key,user:t,creationDate:new Date}),e.ldclient.user=t};var i=e.document.createElement("script");i.type="text/javascript",i.async=!0,i.crossorigin="anonymous",i.src=t;var c=e.document.getElementsByTagName("script")[0];c.parentNode.insertBefore(i,c)}(this,"https://app.launchdarkly.com/snippet/events/v1/56a929db836f3506d400157e.js");</script>',
    prod: '<script crossorigin="anonymous" src="https://app.launchdarkly.com/snippet/features/558af4dc8a25dc2720000009.js"></script><script>!function(e,t){function n(e){e.key&&(e.key=e.key.toString())}e.ldclient=e.ldclient||{},e.ldclient.q||(e.ldclient.q=[]),e.ldclient.push_event=function(t,n,i){e.ldclient.q.push({kind:t,key:n,data:i,url:e.location.href,creationDate:new Date})},e.ldclient.track=e.ldclient.send_event=function(t,n){if("string"!=typeof t)throw"Event key must be a string";e.ldclient.push_event("custom",t,n)},e.ldclient.set_user=e.ldclient.identify=e.ldclient.identify||function(t){n(t),e.ldclient.q.push({kind:"identify",key:t.key,user:t,creationDate:new Date}),e.ldclient.user=t};var i=e.document.createElement("script");i.type="text/javascript",i.async=!0,i.crossorigin="anonymous",i.src=t;var c=e.document.getElementsByTagName("script")[0];c.parentNode.insertBefore(i,c)}(this,"https://app.launchdarkly.com/snippet/events/v1/558af4dc8a25dc2720000009.js");</script>',
  },

  // here's how the wac environments are mapped to LD environments
  wacEnvToScriptMap: {
    local: "local",
    unknown: "dev",
    author: "dev",
    proof: "prod",
    qa: "prod",
    prod: "prod",
  },

  init: function (environment) {
    if (!environment) {
      environment = cst.support.imkt.getWacEnv();
    }
    $("head").append(
      cst.support.darkfeatures.initScripts[
        cst.support.darkfeatures.wacEnvToScriptMap[environment]
      ]
    );
  },
  identify: function (customKeyMap) {
    if (cst.support.darkfeatures.enabled()) {
      var userAnonId = cst.support.analytics.getAtlAnonymousId();
      var user = {
        key: userAnonId,
        anonymous: true,
      };
      if (customKeyMap) {
        user.custom = customKeyMap;
      }
      ldclient.identify(user);
    }
  },
  checkFeatureFlag: function (flagKey, defaultValue) {
    if (cst.support.darkfeatures.enabled()) {
      return ldclient.toggle(flagKey, defaultValue);
    } else {
      return defaultValue;
    }
  },
  enabled: function () {
    return typeof ldclient !== "undefined";
  },
};

cst.support.analytics = {
  checkForSegmentAnalytics: function () {
    if (typeof analytics !== "undefined") {
      return true;
    } else {
      console.info(
        "Info: segment.com analytics tracking code on page, but segment is not initialized."
      );
      return false;
    }
  },

  getAtlAnonymousId: function () {
    var anonId = null;
    if (typeof ace !== "undefined") {
      anonId = ace.analytics.SegmentIO.getAnonymousId();
    }

    // this is just needed for local development, it's a copy of what getAnonymousId does, but can set a local cookie
    if (!anonId) {
      var ANON_ID = "ajs_anonymous_id";
      anonId = cst.support.ace.readCookie(ANON_ID);
      if (!anonId) {
        anonId = cst.support.ace.guidNoDashes();
        // for local development, anonymousId only lasts 1 day
        cst.support.ace.writeCookie(ANON_ID, anonId, 1, false);
      }
    }

    return anonId;
  },

  getEmailDomain: function (emailAddress) {
    var domainRegex = /@(.*$)/;
    var match = domainRegex.exec(emailAddress);
    return match !== null ? match[1] : "";
  },

  getStandardAnalyticsEventProperties: function (target) {
    var rawText;

    if (target.is("form")) {
      rawText = target.attr("name");
    } else {
      rawText = target.text();
      if (rawText === "") {
        var imgLink = target.find("img");
        if (imgLink.length > 0) {
          rawText = imgLink.attr("alt");
        }
      }
    }

    // following event style of WAC analytics
    var eventLabel =
      typeof rawText !== "undefined"
        ? rawText.toLowerCase().replace(/\s+/g, "-").trim()
        : "";
    var eventCategory =
      typeof document.title !== "undefined"
        ? document.title.replace(/\W+/g, "_").trim()
        : "";
    var properties = { category: eventCategory, label: eventLabel };

    return properties;
  },

  getNonPiiFormDataMap: function (jqForm) {
    var formData = jqForm.serialize();
    var nvps = formData.split("&");
    var map = {};
    // add all of the form name/value pairs as event properties
    $.each(nvps, function (i, val) {
      var nvp = val.split("=");

      // exclude the self-help-path field because we are tracking it as a separate property
      if (nvp[0] != "selfhelp_path") {
        // filter out free-text fields so we don't get PII into analytics
        var formField = $("[name='" + nvp[0] + "']");
        var fieldTag = formField.prop("tagName");
        var inputType = formField.attr("type");
        fieldTag =
          typeof fieldTag !== "undefined" ? fieldTag.toLowerCase() : "";
        inputType =
          typeof inputType !== "undefined" ? inputType.toLowerCase() : "";
        if (
          fieldTag == "select" ||
          inputType == "radio" ||
          inputType == "hidden" ||
          inputType == "checkbox"
        ) {
          map["form-field:" + nvp[0]] = decodeURIComponent(nvp[1]);
        } else if (inputType == "email") {
          // capture email domains
          // not hp email field
          if (nvp[0] != "customer_email") {
            map["form-field:" + nvp[0]] = cst.support.analytics.getEmailDomain(
              decodeURIComponent(nvp[1])
            );
          }
        }
      }
    });
    return map;
  },
};

cst.support.aui = {
  MESSAGE_ID: "aui-message-bar",
  message: function (messageType, title, text) {
    var titleHtml = $("<p>")
      .addClass("title")
      .html("<strong>" + title + "</strong>");
    var textHtml = $("<p>").html(text);
    return $("<div>")
      .attr("id", this.MESSAGE_ID)
      .addClass("aui-message aui-message-" + messageType)
      .html(titleHtml[0].outerHTML + textHtml[0].outerHTML)
      .css({
        "margin-top": "10px",
        "margin-bottom": "10px",
      });
  },
};

cst.support.imkt = {
  getWacEnv: function () {
    var getEnvFromPageUrl = function (pageUrl) {
      var requestDomain = url.getHostname(pageUrl);

      /**
       * this prod url pattern says that prod url has just 3 parts to the domain and the middle part is atlassian.
       * Prod Examples: www.atlassian.com, de.atlassian.com, www.atlassian.de, www.atlassian.io.
       * Non Prod Examples: test.internal.atlassian.com, magnolia-5-author-fe-1.internal.atlassian.com
       */
      var prodUrlPattern = /^([^\.]*)\.atlassian\.[^\.]*$/i;
      var qaSubPattern = /qa/i;
      var qaPattern = /^[^\.]*qa[^\.]*\./i;
      var proofPattern = /^[^\.]*proof[^\.]*\./i;
      var localhostPattern = /^localhost:?\d*/i;

      var prodMatch = prodUrlPattern.exec(requestDomain);
      if (prodMatch !== null && !prodMatch[1].match(qaSubPattern)) {
        return "prod";
      }

      if (requestDomain.match(localhostPattern)) {
        return "local";
      }

      if (requestDomain.match(qaPattern)) {
        return "qa";
      }

      if (requestDomain.match(proofPattern)) {
        return "proof";
      }

      return null;
    };

    var pageUrl = window.location.href;
    if (cst.support.forms.simPageUrl) {
      pageUrl = cst.support.forms.simPageUrl;
    }
    var urlEnv = getEnvFromPageUrl(pageUrl);
    if (urlEnv) {
      return urlEnv;
    }

    if (typeof imkt.constants.rootPath === "undefined") {
      return "unknown";
    } else if (
      imkt.constants.rootPath === "../wac-resources/" ||
      imkt.constants.rootPath === "/dev-author/"
    ) {
      return "local";
    } else if (imkt.constants.rootPath === "/magnolia-author/") {
      return "author";
    } else {
      return "unknown";
    }
  },
};

cst.support.aui.validation = {
  /**
   * These variables and functions are mostly borrowed from AUI src because we need insight into the validation state
   * of the form and AUI does not throw an event for failed form validation.
   */
  EVENT_INVALID_SUBMIT: "cst-aui-invalid-submit",
  ATTRIBUTE_FIELD_STATE: "aui-validation-state",
  ATTRIBUTE_FIELD_MESSAGE: "aui-notification-error",
  CLASS_VALIDATION_INITIALISED: "_aui-form-validation-initialised",
  INVALID: "invalid",
  VALID: "valid",
  VALIDATING: "validating",
  UNVALIDATED: "unvalidated",

  getFieldState: function ($field) {
    return $field.attr(
      "data-" + cst.support.aui.validation.ATTRIBUTE_FIELD_STATE
    );
  },

  getFormStateName: function ($form) {
    var $fieldCollection = $form.find(
      "." + cst.support.aui.validation.CLASS_VALIDATION_INITIALISED
    );
    var fieldStates =
      cst.support.aui.validation.getFieldCollectionStateNames($fieldCollection);
    var wholeFormState = cst.support.aui.validation.mergeStates(fieldStates);
    return wholeFormState;
  },

  getFieldCollectionStateNames: function ($fields) {
    var states = $.map($fields, function (field) {
      return cst.support.aui.validation.getFieldState($(field));
    });
    return states;
  },

  mergeStates: function (stateNames) {
    var containsInvalidState =
      stateNames.indexOf(cst.support.aui.validation.INVALID) !== -1;
    var containsUnvalidatedState =
      stateNames.indexOf(cst.support.aui.validation.UNVALIDATED) !== -1;
    var containsValidatingState =
      stateNames.indexOf(cst.support.aui.validation.VALIDATING) !== -1;

    if (containsInvalidState) {
      return cst.support.aui.validation.INVALID;
    } else if (containsUnvalidatedState) {
      return cst.support.aui.validation.UNVALIDATED;
    } else if (containsValidatingState) {
      return cst.support.aui.validation.VALIDATING;
    } else {
      return cst.support.aui.validation.VALID;
    }
  },

  getFieldMessage: function ($field) {
    var msgArray = [];
    var msg = $field.attr(
      "data-" + cst.support.aui.validation.ATTRIBUTE_FIELD_MESSAGE
    );
    if (msg) {
      msgArray = JSON.parse(msg);
    }
    if (msgArray.length > 0) {
      return msgArray[0];
    } else {
      return "";
    }
  },

  getInvalidFieldsAndMessages: function ($form) {
    var fields = [];
    var $fieldCollection = $form.find(
      "." + cst.support.aui.validation.CLASS_VALIDATION_INITIALISED
    );

    $fieldCollection.each(function () {
      var $field = $(this);
      if (
        cst.support.aui.validation.getFieldState($field) ==
        cst.support.aui.validation.INVALID
      ) {
        var obj = {};
        obj.field = $field.attr("name");
        obj.message = cst.support.aui.validation.getFieldMessage($field);
        fields.push(obj);
      }
    });
    return fields;
  },

  /**
   * This function checks the validation state of a form. If validation has not started or is in progress,
   * it sets a timeout to check again in 100ms. If the form is valid, it just returns. If the form is invalid,
   * it throws a new event cst-aui-invalid-submit.
   */
  startFormValidationEventLoop: function ($form) {
    if (typeof $form === "undefined") {
      $form = {};
    }
    var formState = cst.support.aui.validation.getFormStateName($form);
    if (formState == cst.support.aui.validation.INVALID) {
      $form.trigger(cst.support.aui.validation.EVENT_INVALID_SUBMIT);
    } else if (
      formState == cst.support.aui.validation.UNVALIDATED ||
      formState == cst.support.aui.validation.VALIDATING
    ) {
      setTimeout(function ($form) {
        cst.support.aui.validation.startFormValidationEventLoop($form);
      }, 100);
    }
  },
};

cst.support.forms = {
  // this pattern is used in JSD email validation (com.atlassian.servicedesk.internal.feature.emailchannel.EmailUtil.java),
  // https://stash.atlassian.com/projects/SDSERVER/repos/servicedesk/browse/sd-components/core-ui/src/main/resources/servicedesk/internal-api/core/util/common-utils/common-utils.js
  VALID_EMAIL_ADDRESS_PATTERN:
    /^[a-zA-Z0-9_\-\+'`\?=\*%\$#!/^\{\|}~\.]+@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9]+)$/,
  // default environment for form submit action
  ACTION_URL_DEFAULT_ENV: "dev",
  // default production domain where these forms will be hosted.
  DEFAULT_PROD_DOMAIN: "www.atlassian.com",
  // default URL to redirect to after submitting form.
  DEFAULT_CONFIRMATION_PAGE: "thanks.html",

  // classes for form framework
  CST_FORM_SUBMIT_ELEMENT_CLASS: "js-cst-form-submit",
  CST_FORM_SUBMIT_DISABLED_CLASS: "js-cst-form-submit-disabled",
  CSS_FORM_SUBMIT_DISABLED_CLASS: "form-submit-disabled",
  CST_SPINNER_CLASS: "js-submit-spinner",
  // the unique css selector to find the WAC environment key
  CST_FORM_ENV_SELECTOR: "#wac-env",
  // the data attribute name for the WAC environment
  CST_FORM_ENV_DATA_ATTR: "env",
  // attribute containing the field description
  CST_FIELD_DESC_ATTR: "data-field-desc",
  // denotes form elements added by automatic form submit framework
  CST_ADDED_DATA_CLASS: "js-cst-added-data",

  // added form post params for form handling
  FORM_KEY_PARAM: "cst_support_forms_data_formKey",
  TIMEZONE_PARAM: "cst_support_forms_data_timezone",
  FIELD_DESC_MAP_PARAM: "cst_support_forms_data_fieldDescMap",
  SEGMENT_ANON_ID_PARAM: "cst_support_forms_data_segmentAnonId",

  // map of environment action urls
  ACTION_URL_ENV_MAP: {
    local: "http://localhost:8080/form/inquiry",
    dev: "https://api.stg.atlassian.com/customer-support/request/inquiry",
    prod: "https://api.atlassian.com/customer-support/request/inquiry",
  },

  // this explicitly maps which WAC environments submit to which support service backend environments
  wacEnvToSupportServicesMap: {
    local: "dev",
    unknown: "dev",
    author: "dev",
    proof: "dev",
    qa: "dev",
    prod: "prod",
  },

  formAction: null,
  simPageUrl: null,

  /**
   * Use this function to override form action in the browser Console for testing.
   * @param action Can be either a url or a token like local, dev, prod
   */
  setFormAction: function (action) {
    cst.support.forms.formAction = action;
  },

  /**
   * Use this function in browser Console to simulate the page url the form is located at.
   * So that it can be tested as if the form is in production.
   * @param simUrl
   */
  simulatePageUrl: function (simPageUrl) {
    cst.support.forms.simPageUrl = simPageUrl;
  },

  // this gets the back-end environment to post to. Default in most WAC environments is "dev".
  getSupportServicesEnvironment: function (form) {
    var wacEnv = cst.support.imkt.getWacEnv();
    return cst.support.forms.wacEnvToSupportServicesMap[wacEnv];
  },

  // call this from a click handler on any form child element to submit the form
  submit: function (targetForm) {
    var form = $(targetForm);
    var submitEnabledElem = $(
      "." + cst.support.forms.CST_FORM_SUBMIT_ELEMENT_CLASS
    );

    // if submit is disabled, return
    if (form.hasClass(cst.support.forms.CST_FORM_SUBMIT_DISABLED_CLASS)) {
      return false;
    }

    // at this point the form submit is actually going through
    form.trigger("final-submit");

    // disable form and add waiting icon while submitting
    form.addClass(cst.support.forms.CST_FORM_SUBMIT_DISABLED_CLASS);
    submitEnabledElem.addClass(
      cst.support.forms.CSS_FORM_SUBMIT_DISABLED_CLASS
    );

    // if spinner span has not already been added, add it to dom after submit element
    var spinner = $("." + cst.support.forms.CST_SPINNER_CLASS);
    if (!spinner.length) {
      // the css for the spinner span works well with our current forms, but for future forms if it doesn't work,
      // the "submit-spinner" class can be used in css for overriding the spinner style
      spinner = $("<span>")
        .addClass(cst.support.forms.CST_SPINNER_CLASS + " submit-spinner")
        .css({
          display: "inline-block",
          position: "relative",
          top: "-11px",
          left: "25px",
        });
      submitEnabledElem.after(spinner);
    }
    AJS.$(spinner).spin("medium");

    // remove error message in case this is a re-submit
    var errorMessage = $("#" + cst.support.aui.MESSAGE_ID);
    if (errorMessage.length) {
      errorMessage.remove();
    }

    /**
     * Disable any hidden form fields that are empty.
     */
    form
      .find(":input:enabled:not(:visible)")
      .filter(function () {
        return !$(this).val();
      })
      .prop("disabled", "true");

    /**
     * Add automatic form submission parameters for the cst forms framework
     */

    // add timezone
    this.addFormData(form, this.TIMEZONE_PARAM, this.getTimezone());

    // add formKey
    this.addFormData(form, this.FORM_KEY_PARAM, form.attr("name"));

    // add form field description mappings
    var fieldDescMap = {};
    form
      .find(":input:enabled[" + cst.support.forms.CST_FIELD_DESC_ATTR + "]")
      .each(function () {
        var inputName = $(this).attr("name");
        var inputDesc = $(this).data("fieldDesc");
        fieldDescMap[inputName] = inputDesc;
      });
    this.addFormData(
      form,
      this.FIELD_DESC_MAP_PARAM,
      JSON.stringify(fieldDescMap)
    );

    // add Segment.com anonymous id
    var segmentAnonId = null;
    if (typeof ace !== "undefined") {
      segmentAnonId = ace.mkt.Cookie.readCookie("ajs_anonymous_id");
    }
    if (segmentAnonId) {
      this.addFormData(form, this.SEGMENT_ANON_ID_PARAM, segmentAnonId);
    }

    // if email address submitted, add that to LaunchDarkly identify
    if (cst.support.darkfeatures.enabled()) {
      var email = form.find("[name='email']").val();
      if (email) {
        var emailDomain = cst.support.analytics.getEmailDomain(email);
        if (emailDomain) {
          var customKeyMap = {};
          customKeyMap.emailDomain = emailDomain;
          cst.support.darkfeatures.identify(customKeyMap);
        }
      }
    }

    /**
     * Heirarchy of logic to figure out where to submit the form:
     *
     * If formAction set via setFormAction (in browser console), check that first.
     * If form tag has an action attribute, try that next.
     * Try to autoconfigure based on Magnolia injected environment element
     * Try to autoconfigure based on URL
     *
     * Once we have the action string, check to see if it is one of our predefined tokens (local, dev, prod), if so, retrieve url.
     * Otherwise use action string as url.
     */

    // possibly set in browser Console using cst.support.forms.setFormAction(action);
    // overrides all other ways of determining form action
    var formAction = cst.support.forms.formAction;
    var formActionOverride = formAction ? true : false;

    // set directly in form html
    if (!formAction) {
      formAction = form.attr("action");
    }

    // autoconfigure by getting form page environment
    if (!formAction) {
      formAction = cst.support.forms.getSupportServicesEnvironment(form);
    }

    // default action
    if (!formAction) {
      formAction = cst.support.forms.ACTION_URL_DEFAULT_ENV;
    }

    // see if action is one of our url map keys
    var actionUrl = cst.support.forms.ACTION_URL_ENV_MAP[formAction];

    // if not, it is the literal url
    if (!actionUrl) {
      actionUrl = formAction;
    }

    /**
     * Heirarchy for configuration of redirect url:
     *      if <form> has data-confirmation-page attribute
     *      if the submit enabled element has an href attribute
     *      default confirmation page url
     */
    var successRedirectUrl =
      form.data("confirmationPage") ||
      submitEnabledElem.attr("href") ||
      this.DEFAULT_CONFIRMATION_PAGE;

    // if form is hosted locally, append .html to redirect url if it is not there. Makes redirect URL compatible for both local and WAC development.
    if (cst.support.imkt.getWacEnv() == "local") {
      if (!successRedirectUrl.match(/\.html$/)) {
        successRedirectUrl += ".html";
      }
    }

    // if form is posting locally, log form data to console
    if (formAction.indexOf("local") === 0) {
      console.log("FORM_DATA: " + form.serialize());
    }

    // used for Selenium tests only. In this case we output the form data to an element on the page so that we can inspect it for tests.
    if (formAction == "test") {
      $("<div>")
        .attr("id", "test-form-data")
        .css("display", "none")
        .html(form.serialize())
        .appendTo(document.body);
    }

    //force cors support to true. IE9's brain dead implementation still seems to work.
    $.support.cors = true;

    var eventProperties =
      cst.support.analytics.getStandardAnalyticsEventProperties(form);
    eventProperties.event = "Submitted";
    eventProperties.eventComponent = "Form";

    //use jQuery forms plugin to submit form for cross browser compatibility
    $(form[0]).ajaxSubmit({
      url: actionUrl,
      type: "POST",
      success: function (data, textStatus, jqXHR) {
        console.log("Form submit successful: " + textStatus + " : " + data);

        eventProperties.success = true;
        tracking.trackEvent("Form Submit", eventProperties);

        window.location.replace(successRedirectUrl);
        return false;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("Error: " + textStatus + " : " + errorThrown);

        // throw up an aui error message
        form.prepend(
          $("<div>").attr("id", cst.support.aui.MESSAGE_ID).css({
            margin: "0 0 20px 0",
          })
        );
        var errorMsg =
          "Sorry your request was unable to be sent at this time. Please try again.";
        AJS.messages.error({
          title: "Error",
          body: "<p> " + errorMsg + " </p>",
        });
        cst.support.scrollTo("#" + cst.support.aui.MESSAGE_ID, 100);

        // reset AUI form validation
        $("[data-aui-validation-state]").attr(
          "data-aui-validation-state",
          "unvalidated"
        );

        // remove added data from form
        $("." + cst.support.forms.CST_ADDED_DATA_CLASS).remove();

        // track this submit failure in analytics

        eventProperties["error-message"] = errorMsg;
        eventProperties.success = false;
        // add all of the form name/value pairs as event properties
        Object.assign(
          eventProperties,
          cst.support.analytics.getNonPiiFormDataMap(form)
        );
        tracking.trackEvent("Form Submit", eventProperties);

        // enable form submit again and remove waiting icon
        spinner.spinStop();
        form.removeClass(cst.support.forms.CST_FORM_SUBMIT_DISABLED_CLASS);
        submitEnabledElem.removeClass(
          cst.support.forms.CSS_FORM_SUBMIT_DISABLED_CLASS
        );
        return false;
      },
    });
  },

  addFormData: function (form, key, value, fieldDescription) {
    var newInput = $("<input>")
      .attr("type", "hidden")
      .attr("name", key)
      .attr("value", value)
      .addClass(cst.support.forms.CST_ADDED_DATA_CLASS);
    if (fieldDescription) {
      newInput.attr(cst.support.forms.CST_FIELD_DESC_ATTR, fieldDescription);
    }
    form.append(newInput);
  },

  // gets the browser timezone in a format that can be used with the SAC timezone custom field
  getTimezone: function () {
    var now = new Date();
    var tzOffset = now.getTimezoneOffset();
    var gmtOffset = Math.round(tzOffset / -60.0);
    // ha ha, javascript
    if (gmtOffset == "-0") {
      gmtOffset = 0;
    }
    return "GMT" + (gmtOffset >= 0 ? "+" : "") + gmtOffset;
  },
};

$(document).ready(function () {
  cst.support.darkfeatures.init();
  cst.support.darkfeatures.identify();

  // see if page has a submit enabled element
  var submitEnabledElem = $(
    "." + cst.support.forms.CST_FORM_SUBMIT_ELEMENT_CLASS
  );
  var submitEnabledForm = $(submitEnabledElem.closest("form"));

  // load jquery.form plugin locally with fallback to CDN
  if (typeof $.fn.ajaxForm === "undefined") {
    // don't allow submit until jquery.form plugin is loaded
    submitEnabledForm.addClass(
      cst.support.forms.CST_FORM_SUBMIT_DISABLED_CLASS
    );
    submitEnabledElem.addClass(
      cst.support.forms.CSS_FORM_SUBMIT_DISABLED_CLASS
    );

    $.getScript(
      imkt.constants.libPath + "jquery-form.js" + imkt.constants.cdnVersionQuery
    ).done(function () {
      submitEnabledForm.removeClass(
        cst.support.forms.CST_FORM_SUBMIT_DISABLED_CLASS
      );
      submitEnabledElem.removeClass(
        cst.support.forms.CSS_FORM_SUBMIT_DISABLED_CLASS
      );
    });
  }

  // check to see if AUI validation is being used
  if (submitEnabledForm.find(":input[data-aui-validation-field]").length) {
    // click submit element does normal form submit which will be intercepted by AUI validation
    submitEnabledElem.on("click", function (event) {
      event.preventDefault();
      submitEnabledForm.submit();
      cst.support.aui.validation.startFormValidationEventLoop(
        submitEnabledForm
      );
      return false;
    });

    // on successful validation, submit using our function
    submitEnabledForm.on("aui-valid-submit", function (event) {
      event.preventDefault();
      cst.support.forms.submit(submitEnabledForm);
      return false;
    });

    if (cst.support.analytics.checkForSegmentAnalytics()) {
      // on failed validation, track as an analytics event
      submitEnabledForm.on(
        cst.support.aui.validation.EVENT_INVALID_SUBMIT,
        function (event) {
          var form = $(event.target);
          var eventProperties =
            cst.support.analytics.getStandardAnalyticsEventProperties(form);

          eventProperties["error-fields"] =
            cst.support.aui.validation.getInvalidFieldsAndMessages(form);

          // add all of the form name/value pairs as event properties
          Object.assign(
            eventProperties,
            cst.support.analytics.getNonPiiFormDataMap(form)
          );
          tracking.trackEvent(
            "Form Validation Error",
            eventProperties
          );
        }
      );
    }
  } else {
    // click submit element does submit using our function
    submitEnabledElem.on("click", function (event) {
      event.preventDefault();
      cst.support.forms.submit(submitEnabledForm);
      return false;
    });
  }
});
